/** Boxicons mapping for sidebar nav (Tenant design system). */

export const SIDEBAR_BX_MAP = {
  BiDesktop: 'bx-grid-alt',
  MdSpaceDashboard: 'bx-grid-alt',
  FcBarChart: 'bx-grid-alt',
  CiDesktop: 'bx-desktop',
  CiBank: 'bx-building',
  FcPortraitMode: 'bx-group',
  LiaUserCogSolid: 'bx-user-check',
  CiCalendarDate: 'bx-calendar',
  VscCalendar: 'bx-calendar',
  HiOutlineCalendarDays: 'bx-calendar-event',
  FcSettings: 'bx-cog',
  MdTune: 'bx-slider-alt',
  FcLibrary: 'bx-book-open',
  FcFilingCabinet: 'bx-folder',
  BsBookHalf: 'bx-book',
  BiBookBookmark: 'bx-book-bookmark',
  BsFileEarmarkPlus: 'bx-file-blank',
  BsClipboard2Check: 'bx-check-double',
  BsCurrencyRupee: 'bx-rupee',
  FcCurrencyExchange: 'bx-transfer-alt',
  CiBadgeDollar: 'bx-dollar-circle',
  HiOutlineChartSquareBar: 'bx-bar-chart-alt-2',
  HiOutlineBell: 'bx-bell',
  FaSearchDollar: 'bx-search-alt',
  FaSchool: 'bx-building-house',
  MdPayments: 'bx-credit-card',
  CiReceipt: 'bx-receipt',
  BsClipboardData: 'bx-spreadsheet',
  BsListTask: 'bx-task',
  BsClipboard2: 'bx-clipboard',
  CiDeliveryTruck: 'bx-bus',
  FcBusinessman: 'bx-briefcase',
  BsClipboardCheck: 'bx-check-square',
  BsFileRuled: 'bx-file',
  LiaAngry: 'bx-error-circle',
  MdBeachAccess: 'bx-sun',
  GoPaste: 'bx-paste',
  BsJournalBookmark: 'bx-bookmark',
  BsJournalText: 'bx-note',
  FcReading: 'bx-user-plus',
  FcConferenceCall: 'bx-group',
  FaUserPlus: 'bx-user-plus',
  FaUserTie: 'bx-id-card',
  BsCalendar2Event: 'bx-calendar-event',
  FaClipboardUser: 'bx-user-plus',
  FaUsersLine: 'bx-group',
  ImOffice: 'bx-buildings',
  BsBuildingAdd: 'bx-building-house',
  BsInfoCircle: 'bx-info-circle',
  BsGlobe2: 'bx-globe',
  BsEnvelopePaper: 'bx-envelope',
  FcBriefcase: 'bx-briefcase',
  CiUser: 'bx-user',
  BsTicketPerforated: 'bx-support',
  CiShoppingCart: 'bx-cart',
  FaPowerOff: 'bx-log-out',
  FcCollapse: 'bx-chevron-up',
  FcExpand: 'bx-chevron-down',
};

export function SidebarIcon({
  name,
  className = '',
  iconClassName = 'sidebar-nav-icon',
  wrapped = true,
  ...rest
}) {
  const bxClass = SIDEBAR_BX_MAP[name] || 'bx-grid-alt';
  const iconClasses = ['bx', bxClass, iconClassName, className].filter(Boolean).join(' ');
  const iconEl = <i className={iconClasses} aria-hidden="true" {...rest} />;
  if (!wrapped) return iconEl;
  return <span className="org-nav-icon">{iconEl}</span>;
}

/** @deprecated use SIDEBAR_BX_MAP — kept for any legacy imports */
export const SIDEBAR_ICON_MAP = SIDEBAR_BX_MAP;
